<script>
  import {
    ETH_PRICE,
    formatAuctionTime,
    GENERATIVE_FILM_URL,
    HIGHLIGHT_URL,
    isAfterLaunchStore,
    LINK_CREATE,
    LINK_HOME,
    SALE_END_DATE,
    SALE_END_DATE_FMT,
    SALE_START_DATE,
    SALE_START_DATE_FMT,
  } from "../util/constants";
  import ExternalLink from "./ExternalLink.svelte";
  import LinkButton from "./LinkButton.svelte";
  import Paragraph from "./Paragraph.svelte";
  import InlineSpan from "./InlineSpan.svelte";

  export let tightParagraph = true;
</script>

<!-- <div class="brief">
  Bitframes is an open source artwork encoded in 32 bytes of data, inspired by
  punched cards and early computer art. Design your own outputs with the <LinkButton
    to={`/${LINK_CREATE}`}
    upper
    inline>create</LinkButton
  > tool, and publish them to the blockchain for a small fee. 100% of the net proceeds
  are being used to fund the production of a feature-length documentary film,
  <ExternalLink italic href={GENERATIVE_FILM_URL}>Generative</ExternalLink>,
  that is currently in development by Tordoff Films.
</div> -->

<div class="tagline">
  A generative art project and film crowdfund by artist Matt DesLauriers.
</div>

<div class="brief">
  Bitframes is an open source artwork encoded in 32 bytes of data, inspired by
  punched cards and early computer art. Mint your designs to the blockchain for
  a small fee, and help crowdfund a documentary film that preserves the history
  of generative art.
</div>

<div class="bullets" style="">
  <div class="bullet-row">
    <div class="label">-</div>
    <div class="bullet-content">
      <Paragraph tight={tightParagraph}
        >Open edition sale & crypto crowdfund powered by <InlineSpan
          ><ExternalLink href={HIGHLIGHT_URL}>Highlight</ExternalLink
          >.</InlineSpan
        ></Paragraph
      >
    </div>
  </div>
  <div class="bullet-row">
    <div class="label">-</div>
    <div class="bullet-content">
      {#if $isAfterLaunchStore}
        <Paragraph tight={tightParagraph}
          >Ran from {SALE_START_DATE_FMT} to {SALE_END_DATE_FMT} (GMT).</Paragraph
        >
      {:else}
        <Paragraph tight={tightParagraph}
          >Runs {SALE_START_DATE_FMT} to {SALE_END_DATE_FMT} (GMT).</Paragraph
        >
      {/if}
    </div>
  </div>
  {#if !$isAfterLaunchStore}
    <div class="bullet-row">
      <div class="label">-</div>
      <div class="bullet-content">
        <Paragraph tight={tightParagraph}
          >Pay what you want above an <strong class="inline"
            >{ETH_PRICE} ETH</strong
          > minimum.</Paragraph
        >
      </div>
    </div>
  {/if}
  <div class="bullet-row">
    <div class="label">-</div>
    <div class="bullet-content">
      <Paragraph tight={tightParagraph}
        >Contributors enter to win one of the limited <LinkButton
          anchor="edition">32 Bit Edition</LinkButton
        > artworks.</Paragraph
      >
    </div>
  </div>
  <div class="bullet-row">
    <div class="label">-</div>
    <div class="bullet-content">
      <Paragraph tight={tightParagraph}
        >100% of net proceeds will be directed to the production of
        <span class="inline"
          ><ExternalLink italic href={GENERATIVE_FILM_URL}
            >Generative</ExternalLink
          >,</span
        > a documentary film on the history of generative art.</Paragraph
      >
    </div>
  </div>
  {#if $isAfterLaunchStore}
    <div class="bullet-row">
      <div class="label">-</div>
      <div class="bullet-content red">
        <Paragraph tight={tightParagraph}
          >The crowdfund is now over, but the website and gallery will remain
          open.</Paragraph
        >
      </div>
    </div>
  {/if}
</div>

<style>
  .tagline {
    font-size: 25px;
    /* max-width: 450px; */
    /* max-width: 400px; */
    max-width: 600px;
    margin-bottom: 20px;
  }
  .red {
    color: #c51919;
    /* font-style: italic; */
  }
  .brief {
    flex-shrink: 1;
    flex-grow: 0;
    /* max-width: 600px; */
    min-width: 250px;
    /* flex-basis: 300px; */
    font-size: 16px;
    box-sizing: border-box;
  }
  .inline {
    display: inline-flex;
  }
  .bullets {
    /* border: 1px solid black; */
    padding: 0px;
    font-size: 12px;
    flex-shrink: 1;
    flex-grow: 1;
    /* max-width: 600px; */
    min-width: 250px;
    /* flex-basis: 300px; */
    box-sizing: border-box;
    --margin: 20px;
    margin-top: var(--margin);
    /* margin-bottom: var(--margin); */
  }
  .bullets,
  .bullet-row,
  .label,
  .bullet-content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    box-sizing: border-box;
    line-height: 1;
  }
  .bullets {
    flex-direction: column;
    gap: 0px;
    width: 100%;
    justify-content: flex-start;
  }
  .bullet-row {
    /* padding-bottom: 5px; */
    /* padding-top: 5px; */
    /* flex-grow: 1; */
    width: 100%;
    --pad: 5px;
    border-bottom: 1px dotted black;
    padding-bottom: var(--pad);
    padding-top: var(--pad);
    align-items: center;
  }

  .bullet-row .label {
    display: none;
    width: 100%;

    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 20px;
  }
  @media screen and (max-width: 720px) {
    .bullet-content {
      /* max-width: 300px; */
    }
  }
</style>
